$(window).on('load', function() {
    $('.count-up').each( function() {
        animateCounter( $(this) );
    })
});

const animationDuration = 2000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round( animationDuration / frameDuration );

const easeOutQuad = t => t * ( 2 - t );

const animateCounter = el => {
    let frame = 0;
    const countTo = parseInt( el.html() );

    const counter = setInterval( () => {
        frame ++;

        const progress = easeOutQuad( frame / totalFrames );
        const currentCount = Math.round( countTo * progress );

        if ( el.html() !== currentCount ) {
            el.html( currentCount );
        }

        if( frame === totalFrames ) {
            clearInterval( counter );
        }
    }, frameDuration);
};
